<template>
  <v-flex xs12>
    <div v-show="loading" class="text-xs-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-show="!loading">
      <h1>こんにちは、{{name}}さん</h1>
    </div>
  </v-flex>
</template>

<script>
  export default {
    async created(){
      if(this.user !== '') {
        this.name = (await this.api('user_getinfo', {})).payload.name
        this.loading = false
      }
    },
    methods:{
      logout(){
        localStorage.removeItem("user")
        this.$router.push({user:""})
        this.$router.go('/')
      },
    },
    data () {
      return{
        loading: true,
        user: localStorage.user || "",
        name: '',
      }
    }
  }
</script>
